// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/css/animated-empty-state.css */
.animated-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  background: var(--bg-glass, rgba(255, 255, 255, 0.5));
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px dashed var(--border-glass, rgba(200, 200, 200, 0.5));
  border-radius: 24px;
  margin: 2rem 0;
  min-height: 300px;
}

.animated-empty-state.is-error {
  background: rgba(239, 68, 68, 0.05);
  border-color: rgba(239, 68, 68, 0.2);
}

.empty-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 90px;
  border-radius: 24px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%);
  color: var(--accent-primary);
  margin-bottom: 1.5rem;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.1);
}

.animated-empty-state.is-error .empty-icon-wrapper {
  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);
  color: #ef4444;
  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.1);
}

.empty-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 0.5rem 0;
}

.empty-subtitle {
  font-size: 1rem;
  color: var(--text-secondary);
  max-width: 400px;
  margin: 0 0 1.5rem 0;
  line-height: 1.5;
}

.empty-action {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/css/animated-empty-state.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,2BAA2B;EAC3B,mCAAmC;EACnC,gEAAgE;EAChE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8FAA8F;EAC9F,4BAA4B;EAC5B,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,4FAA4F;EAC5F,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["/* src/css/animated-empty-state.css */\n.animated-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  background: var(--bg-glass, rgba(255, 255, 255, 0.5));\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px dashed var(--border-glass, rgba(200, 200, 200, 0.5));\n  border-radius: 24px;\n  margin: 2rem 0;\n  min-height: 300px;\n}\n\n.animated-empty-state.is-error {\n  background: rgba(239, 68, 68, 0.05);\n  border-color: rgba(239, 68, 68, 0.2);\n}\n\n.empty-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 90px;\n  height: 90px;\n  border-radius: 24px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(99, 102, 241, 0.05) 100%);\n  color: var(--accent-primary);\n  margin-bottom: 1.5rem;\n  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.1);\n}\n\n.animated-empty-state.is-error .empty-icon-wrapper {\n  background: linear-gradient(135deg, rgba(239, 68, 68, 0.1) 0%, rgba(239, 68, 68, 0.05) 100%);\n  color: #ef4444;\n  box-shadow: 0 10px 30px rgba(239, 68, 68, 0.1);\n}\n\n.empty-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 0.5rem 0;\n}\n\n.empty-subtitle {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  max-width: 400px;\n  margin: 0 0 1.5rem 0;\n  line-height: 1.5;\n}\n\n.empty-action {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
